var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormaliconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Normal_icon_-_black",
    "data-name": "Normal icon - black",
    transform: "translate(-341 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2946",
    "data-name": "Rectangle 2946",
    transform: "translate(341 55)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-dashboard-4463423",
    transform: "translate(254.338 38.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12442",
    "data-name": "Path 12442",
    d: "M96.052,19.338a1.831,1.831,0,0,0-1.83-1.83H89.34a1.831,1.831,0,0,0-1.83,1.83v4.881a1.831,1.831,0,0,0,1.83,1.83h4.881a1.831,1.831,0,0,0,1.83-1.83V19.338Zm-1.22,0v4.881a.611.611,0,0,1-.611.611H89.34a.611.611,0,0,1-.611-.611V19.338a.611.611,0,0,1,.611-.611h4.881a.611.611,0,0,1,.611.611Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12443",
    "data-name": "Path 12443",
    d: "M96.052,299.34a1.831,1.831,0,0,0-1.83-1.83H89.34a1.831,1.831,0,0,0-1.83,1.83v4.881a1.831,1.831,0,0,0,1.83,1.83h4.881a1.831,1.831,0,0,0,1.83-1.83Zm-1.22,0v4.881a.611.611,0,0,1-.611.611H89.34a.611.611,0,0,1-.611-.611V299.34a.611.611,0,0,1,.611-.611h4.881A.611.611,0,0,1,94.832,299.34Z",
    transform: "translate(0 -270.239)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12444",
    "data-name": "Path 12444",
    d: "M376.052,19.338a1.831,1.831,0,0,0-1.831-1.83h-4.881a1.831,1.831,0,0,0-1.831,1.83v4.881a1.831,1.831,0,0,0,1.831,1.83h4.881a1.831,1.831,0,0,0,1.831-1.83V19.338Zm-1.22,0v4.881a.611.611,0,0,1-.611.611h-4.881a.611.611,0,0,1-.611-.611V19.338a.611.611,0,0,1,.611-.611h4.881a.611.611,0,0,1,.611.611Z",
    transform: "translate(-270.237)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12445",
    "data-name": "Path 12445",
    d: "M376.052,299.34a1.831,1.831,0,0,0-1.831-1.83h-4.881a1.831,1.831,0,0,0-1.831,1.83v4.881a1.831,1.831,0,0,0,1.831,1.83h4.881a1.831,1.831,0,0,0,1.831-1.83Zm-1.22,0v4.881a.611.611,0,0,1-.611.611h-4.881a.611.611,0,0,1-.611-.611V299.34a.611.611,0,0,1,.611-.611h4.881A.611.611,0,0,1,374.832,299.34Z",
    transform: "translate(-270.237 -270.239)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormaliconBlack);
export default __webpack_public_path__ + "static/media/normalicon - black.b3c68abeeaab5a963668cf54788f25ce.svg";
export { ForwardRef as ReactComponent };